/* exported NSChatNotifications */
/* global Howl, Push, faviconUrl */
/** NSChatNotifications module
 *
 * Triggers browser notifcation, updates browser title, and highlights chat window
 *
 * @requires jquery library
 * @requires push.js notifications library
 * @requires howler.js sound playback library
 */
var NSChatNotifications = (function () {
  // chatNotifcation settings
  var s = {
    titleInterval: false,
    titlesArray: [{ id: 'default', title: document.title }],
    titleIndex: 0,
    notificationSound: new Howl({
      src: [
        '/portal/audio/chat_notification.mp3',
        '/portal/audio/chat_notification.wav'
      ]
    }),
    soundCooldown: false
  };

  /** play a notification sound and set a 5 second sound cooldown
   *
   * @private
   */
  var playSound = function () {
    s.notificationSound.play();
    s.soundCooldown = true;

    setTimeout(function () {
      s.soundCooldown = false;
    }, 5000);
  };

  /** change the title to whatever is next in the titlesArray object
   *
   * @private
   */
  var changeTitle = function () {
    // increment up to the length of the array, then start back at beginning
    s.titleIndex = (s.titleIndex + 1) % s.titlesArray.length;

    var newTitle = s.titlesArray[s.titleIndex].title;

    document.title = newTitle;
  };

  /** remove a session's title from the titlesArray
   * clear the interval if there are no more notification titles
   *
   * @param {string} sessionId is the ID for a session
   *
   * @private
   */
  var removeTitle = function (sessionId) {
    // loops through titlesArray and removes the title for the corresponding notification
    for (var i = 0; i < s.titlesArray.length; i += 1) {
      if (s.titlesArray[i].id == sessionId) {
        s.titlesArray.splice(i, 1); // removes 1 element at position i
        break;
      }
    }

    // when there are no more new notification titles in the array
    // remove the interval and reset the title to default page title
    if (s.titlesArray.length == 1) {
      clearInterval(s.titleInterval);
      s.titleInterval = false;
      document.title = s.titlesArray[0].title;
    }
  };

  /** focus the chat box
   *
   * @param {object} options contains all of the options for the notification
   *
   * @private
   */
  var focusChat = function (options) {
    var id = 'uc-message-box-' + options.session_id;
    var box = '#' + id;
    var $chatMessages = $(box + ' .chat-messages');

    window.focus();
    // resets all elements to default scroll position
    $('.dock-popup-overlay').prepend($(box));
    $chatMessages.scrollTop($chatMessages[0].scrollHeight);
    document.getElementById(id).querySelector('.message-to-send')
      .focus();
  };

  /** remove all notification indicators for a session or message
   *
   * @param {string} sessionId is the ID for a session
   * @param {string} messageId is the ID for a message within a session
   * */
  var removeNotification = function (sessionId, messageId) {
    var messageBox = document.getElementById('uc-message-box-' + sessionId);

    // new-message class controls dock-head color
    $(messageBox).removeClass('new-message');

    // remove bold from recent row
    var recentRow = document.getElementById('recent-' + sessionId);

    if (recentRow != null) {
      recentRow.style.fontWeight = '';
    }

    removeTitle(sessionId);

    if (messageId) {
      Push.close(messageId);
    }
  };

  /** Show a browser notification
   *
   * @param {object} options contains all of the options for the notification
   *
   * @private
   */
  var addBrowserNotification = function (options) {
    var title = options.title + ' ' + _('says...');

    if (Push.Permission.has()) {
      Push.create(title, {
        body: options.body,
        tag: options.message_id,
        icon: faviconUrl, // this is a global variable found in the layout file (e.g. portal.ctp)
        timeout: 6000,
        onClick: function () {
          focusChat(options);
          removeNotification(options.session_id, options.message_id);
        }
      });
    } else {
      console.warn('Caught (in chat-notifications.js) PushError: permission request declined');
    }
  };

  /** Start a new notification. Notification can flash the chat container,
   * flash the title and play a sound
   *
   * @param {object} options contains all of the options for the notification
   * */
  var newNotification = function (options) {
    var messageBox = document.getElementById('uc-message-box-' + options.session_id);

    // TODO: pretty format options.title (phone number)

    // if tab not focused, fire browser notification and play sound
    if (!document.hasFocus()) {
      addBrowserNotification(options);

      // only play sound if no cooldown exists
      if (!s.soundCooldown) {
        playSound();
      }

      // make text bold in recents
      var recentRow = document.getElementById('recent-' + options.session_id);

      if (recentRow != null) {
        recentRow.style.fontWeight = 'bold';
      }
    }

    // check if chat is in focus, if not update flash browser title and add highlight
    if (!$(messageBox).find('.message-to-send')
      .is(':focus')
    ) {
      var newTitle = options.title + ' ' + _('says...');

      // add title for notification to array
      s.titlesArray.push({ id: options.session_id, title: newTitle });

      if (s.titleInterval == false) {
        // loop through titlesArray and flash the title at the set interval,
        // including the original title
        s.titleInterval = window.setInterval(changeTitle, 2000);
      }

      // new-message class controls dock-head color
      $(messageBox).addClass('new-message');
    }
  };

  return {
    notify: newNotification,
    remove: removeNotification
  };
}());
